module.exports = __webpack_public_path__ + "static/media/icon-date.a221a196.png";